import * as R from 'ramda'
export const docuSignStatus: {
  [key: string]: string;
} = {
  QUOTING: 'QUOTING',
  t2: 't2'

}
export const docuSignStatusKeys = R.keys(docuSignStatus)
export const docuSignStatusValues = R.values(docuSignStatus)
